export const FEEDBACK_STATUS = [
  {
    value: "PENDING",
    label: "Pending",
  },
  {
    value: "RESOLVED",
    label: "Resolved",
  },
  {
    value: "REJECTED",
    label: "Rejected",
  }
];



export interface ITestimonial {
  customerName: string;
  customerDesignation: string;
  customerImage: string;
  testimonial: string;
  rating: number;
  orderPriority: number;
  isActive: boolean;
  id: string;
}
